function searchVendors () {
  const filter = document.getElementById('search-vendors-input').value
  const ul = document.getElementById('vendors-home-list')
  const li = ul.getElementsByTagName('li')
  for (let i = 0; i < li.length; i++) {
    const elemText = li[i].getElementsByTagName('a')[0].text
    li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
  }
}

const searchVendorInput = $('#search-vendors-input')

searchVendorInput.focusin(function () {
  $('#vendors-home-list').fadeIn('fast')
})
searchVendorInput.focusout(function () {
  $('#vendors-home-list').fadeOut(1000)
})
searchVendorInput.on('keyup', function () { searchVendors() })













